import { render, staticRenderFns } from "./wxl-list-item.vue?vue&type=template&id=5c39568c&scoped=true"
import script from "./wxl-list-item.vue?vue&type=script&lang=js"
export * from "./wxl-list-item.vue?vue&type=script&lang=js"
import style0 from "./wxl-list-item.vue?vue&type=style&index=0&id=5c39568c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39568c",
  null
  
)

export default component.exports